import { computed } from 'mobx';
import ApiModel     from 'models/globals/ApiModel';

export default class RoleModel extends ApiModel {
  static get path() {
    return '/backend/roles/{?id}';
  }

  @computed
  get label(): string {
    return this.get('reference');
  }

  @computed
  get reference(): string {
    return this.get('reference');
  }
}
